// frontend/src/components/ChatSidebar/LivestockSuccessMessage.tsx
/**
 * Displays success message after livestock is added or marked deceased.
 *
 * Shows different styling based on the action:
 * - Green check icon for adding livestock
 * - Red broken heart icon for deceased entries
 */
import { Paper, Text, Group, ThemeIcon } from '@mantine/core';
import { IconCheck, IconHeartBroken } from '@tabler/icons-react';
import type { LivestockAddedEntry } from '@/api/chat';

interface LivestockSuccessMessageProps {
  entry: LivestockAddedEntry;
  message: string;
  isDeceased: boolean;
}

export function LivestockSuccessMessage({
  entry,
  message,
  isDeceased,
}: LivestockSuccessMessageProps) {
  return (
    <Paper p="sm" radius="md" withBorder>
      <Group gap="xs" mb={4}>
        <ThemeIcon
          size="sm"
          color={isDeceased ? 'red' : 'green'}
          variant="light"
          radius="xl"
        >
          {isDeceased ? <IconHeartBroken size={14} /> : <IconCheck size={14} />}
        </ThemeIcon>
        <Text size="sm" fw={500}>
          {message}
        </Text>
      </Group>
      <Text size="xs" c="dimmed">
        {entry.tank_name}
      </Text>
    </Paper>
  );
}
